import React from 'react';
import PropTypes from 'prop-types';
import { Form, notification, Spin } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';

import * as S from '../styles';
import api from '../../../services/api';

function EsqueciMinhaSenha({ onClickVoltar }) {
  const [loading, setLoading] = React.useState(false);
  const [sucesso, setSucesso] = React.useState(false);

  const enviarSenha = React.useCallback(async form => {
    setLoading(true);

    try {
      await api.post('/usuarios/esqueciMinhaSenha', {
        login: form.login,
      });

      setSucesso(true);
    } catch (e) {
      setSucesso(false);
      notification.error({
        message: 'Ops...',
        description:
          e?.response?.data?.message ??
          'Não foi possível enviar as instruções por e-mail no momento',
      });
    } finally {
      setLoading(false);
    }
  }, []);

  if (loading || sucesso) {
    return (
      <>
        <S.FeedbackPanel role="status" aria-live="polite">
          <S.FormHeading>
            <h1>
              {loading ? 'Processando...' : 'E-mail enviado com sucesso!'}
            </h1>
            <p>
              {loading
                ? 'Estamos processando sua solicitação, aguarde!'
                : 'As instruções foram enviadas para seu e-mail. Caso não receba dentro de alguns minutos, faça uma nova solicitação.'}
            </p>
          </S.FormHeading>
          {loading && <Spin />}
        </S.FeedbackPanel>
        {sucesso && (
          <S.CenteredAction>
            <S.LinkButton onClick={onClickVoltar} type="link">
              <ArrowLeftOutlined />
              Voltar para login
            </S.LinkButton>
          </S.CenteredAction>
        )}
      </>
    );
  }

  return (
    <S.FormAntd
      onFinish={enviarSenha}
      layout="vertical"
      id="form"
      requiredMark={false}
    >
      <S.FormHeading>
        <h1>Esqueceu sua senha?</h1>
        <p>
          Digite seu CPF e enviaremos instruções por e-mail sobre como criar uma
          nova senha.
        </p>
      </S.FormHeading>
      <Form.Item
        name="login"
        label="CPF"
        rules={[{ required: true, message: 'Por favor, entre com seu cpf!' }]}
      >
        <S.CpfInput
          size="large"
          mask="000.000.000-00"
          placeholder="CPF"
          autoComplete="username"
          inputMode="numeric"
          data-testid="inputCpf"
        />
      </Form.Item>
      <S.PrimaryButton
        size="large"
        htmlType="submit"
        id="entrar"
        loading={loading}
        aria-hidden={loading}
        data-testid="submitBtn"
      >
        Enviar e-mail
      </S.PrimaryButton>
      <S.CenteredAction>
        <S.LinkButton onClick={onClickVoltar} type="link" data-testid="voltar">
          <ArrowLeftOutlined />
          Voltar para login
        </S.LinkButton>
      </S.CenteredAction>
    </S.FormAntd>
  );
}

EsqueciMinhaSenha.propTypes = {
  onClickVoltar: PropTypes.func,
};

EsqueciMinhaSenha.defaultProps = {
  onClickVoltar: () => {},
};

export default EsqueciMinhaSenha;
